export enum Offers {
  Essential = 'Essentielle',
  CustomerPath = 'Parcours client',
  CustomerEngagement = 'Engagement client',
  Custom = 'Libre',
}
